var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupsHouses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7999 3.94282C10.7999 5.48922 9.54635 6.74282 7.99995 6.74282C6.45355 6.74282 5.19995 5.48922 5.19995 3.94282C5.19995 2.39642 6.45355 1.14282 7.99995 1.14282C9.54635 1.14282 10.7999 2.39642 10.7999 3.94282ZM14.3999 6.74282C14.3999 7.6265 13.6836 8.34282 12.7999 8.34282C11.9163 8.34282 11.1999 7.6265 11.1999 6.74282C11.1999 5.85917 11.9163 5.14282 12.7999 5.14282C13.6836 5.14282 14.3999 5.85917 14.3999 6.74282ZM3.19995 8.34282C4.0836 8.34282 4.79995 7.6265 4.79995 6.74282C4.79995 5.85917 4.0836 5.14282 3.19995 5.14282C2.31629 5.14282 1.59995 5.85917 1.59995 6.74282C1.59995 7.6265 2.31629 8.34282 3.19995 8.34282Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.2 13.9428C2.75818 13.9428 2.4 13.5846 2.4 13.1428V12.7428C2.39999 10.3127 4.36994 8.34277 6.8 8.34277H9.2C11.6301 8.34277 13.6 10.3127 13.6 12.7428V13.1428C13.6 13.5846 13.2418 13.9428 12.8 13.9428H3.2ZM0.936568 13.9428C0.848128 13.6925 0.8 13.4233 0.8 13.1428V12.7428C0.8 11.6416 1.09666 10.6097 1.61441 9.72261C0.644344 10.3905 0 11.5703 0 12.9142V13.2571C0 13.6357 0.281424 13.9428 0.628568 13.9428H0.936568ZM14.4779 9.88669C14.9385 10.736 15.2 11.7089 15.2 12.7428V13.1428C15.2 13.4233 15.1518 13.6925 15.0634 13.9428H15.3143C15.693 13.9428 16 13.6358 16 13.2571V12.9142C16 11.6743 15.4017 10.5741 14.4779 9.88669Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsHouses);
export default __webpack_public_path__ + "static/media/GroupsHouses.7c718c3d0b623bda45a712abadf3e603.svg";
export { ForwardRef as ReactComponent };